import { useContext } from "react";
import { useHistory,useLocation  } from "react-router-dom";
import UserContext from "../Context/AppContext";
import { auth } from "../Utils/api";

const usePrivilegios=()=>
{
    const Location = useLocation();
    const History=useHistory();
    const User=auth.currentUser;
    
    if(User ===null)
    {
        const {pathname} = Location;
        
        localStorage.setItem("pathToLogin",pathname);

        History.replace("/login");
    }
}

export default usePrivilegios;